import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';


export interface iRoadInputValue{
  number: string;
  season: string;
  year: string;
}
export interface iRoadInfo{
  [key:string]:iRoadInputValue;
}
export interface iNameTokenPair{
  name:string;
  token:string;
}
export function createRoadYears():iNameTokenPair[]{
  let start = 2019;
  let end  = (new Date()).getFullYear() + 1;
  let qty = end-start;

  const roadYears=[];
  for(let i=0;i<qty;i++){
    let token = String(start).slice(-1);
    let name = `${start}-${++start}`;
    roadYears.push({
      name,token
    });
  }
  return roadYears.reverse();
}
@Component({
  selector: 'app-roadinfo-editor',
  templateUrl: './roadinfo-editor.component.html',
  styleUrls: ['./roadinfo-editor.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: RoadinfoEditorComponent,
      multi: true
    }
  ]
})
export class RoadinfoEditorComponent  implements ControlValueAccessor,OnInit {
  private onChange: Function = (date: string) => { };
  private onTouch: Function = () => { };
  @Output() valueChanged:EventEmitter<any> = new EventEmitter<any>();
  @Input() disabled: boolean = false;
  public roadInfo: iRoadInfo;
  get invalid():boolean{
   return false;
  }
  @Input()
  set value(value: iRoadInfo) {
    this.writeValue(value);
    // this.valueChanged.emit(value);
  }
  get value(): iRoadInfo {
    if(this.invalid) return;
    return this.roadInfo;
  }
  public seasons:iNameTokenPair[] = [ {
    name: 'HIVER',
    token: 'H'
  },{
    name:'ETE',
    token: 'G'
  }];
  public roadYears:iNameTokenPair[] = createRoadYears();
  public roadNumbers:string[]=[];
  constructor() {
  console.log({roadYEars:this.roadYears})}
  writeValue(obj: iRoadInfo): void {
    if(this.disabled) return;
    this.onChange(obj);
    if(obj){
      this.roadNumbers = Object.keys(obj);
      this.roadInfo = obj;
    }else{
      this.roadInfo = {};
    }

  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
  seasonChanged( key, value ){
    this.roadInfo[key].season=value;
    console.log('emite val change season')
      this.valueChanged.emit( this.roadInfo );

  }
  yearChanged(key, value){
    this.roadInfo[key].year=value;
        console.log('emite val change year')
    this.valueChanged.emit( this.roadInfo );


  }
  sorted(a,b){
    let nameA = parseInt(a.name);
    let nameB = parseInt(b.name);
    return nameA-nameB;
  }
  newRoadInfoChanged(arg){

  }
  delete(key){
    delete this.roadInfo[key];
        console.log('emite val change dekete')
    this.valueChanged.emit( this.roadInfo );
  }
  addRoad(info){
    console.log('arrRoad',info.number)
    let number =info.number;
    if(!this.roadInfo[number]){
      this.roadInfo[number]=info;
    }else{
      this.roadInfo[number] = Object.assign({},this.roadInfo[number],info);
    }
        console.log('emite val change add')
    this.valueChanged.emit( this.roadInfo );
  }

  ngOnInit() {}

}
